
import * as countries from 'i18n-iso-countries';
import * as es from 'i18n-iso-countries/langs/es.json';
import * as en from 'i18n-iso-countries/langs/en.json';

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';

declare const require: (arg0: string) => countries.LocaleData;


export class LangFlag {

  flag: string;
  lang: string;
  fullLang: string;
  locale: string;

  constructor(flag: string, lang: string, fullLang: string, locale: string) {
    this.flag = flag;
    this.lang = lang;
    this.fullLang = fullLang;
    this.locale = locale;
  }
}

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  readonly defaultLang = 'es';
  readonly defaultFlag = 'es';
  readonly defaultLocale = 'es-ES';

  configuredLangs: LangFlag[] = [];

  currentLang !: string;
  currentLocale = 'es';

  private langSubject = new BehaviorSubject<string>(this.defaultLang);
  private flagSubject = new BehaviorSubject<string>(this.defaultFlag);
  private localeSubject = new BehaviorSubject<string>(this.currentLocale);

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public lang$ = this.langSubject.asObservable();
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public flag$ = this.flagSubject.asObservable();
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public locale$ = this.localeSubject.asObservable();

  constructor(private translate: TranslateService, private primengConfig: PrimeNGConfig) {
    const browserLang = navigator.language.split('-')[0]; // Get the browser language
    const defaultLang = localStorage.getItem('lang') ?? this.defaultLang;

    translate.setDefaultLang(defaultLang);

    this.updateLangs();

    const lang: string = this.configuredLangs.find(l => l.lang === browserLang)?.lang ?? defaultLang;
    this.changeLang(lang);
    this.configureCountries();
  }

  public changeLang(lang: string): void {
    if (lang == null) {
      return;
    }

    const configuredLang = this.configuredLangs.find(l => l.lang === lang);
    this.langSubject.next(lang);
    this.translate.use(lang);
    this.translate.get('primeng').subscribe(value => {
      this.primengConfig.setTranslation(value)
    })
    this.currentLang = lang;
    localStorage.setItem('lang', lang);

    if (configuredLang != null) {
      this.flagSubject.next(configuredLang.flag);
      this.localeSubject.next(configuredLang.locale);
      this.currentLocale = configuredLang.locale;
    }
  }

  public updateLangs(): void {
    this.configuredLangs = [];

    this.configuredLangs.push(new LangFlag('es', 'es', 'Español', 'es-ES'));
    this.configuredLangs.push(new LangFlag('gb', 'en', 'English', 'en-GB'));
  }

  private configureCountries() {
    this.configuredLangs.forEach(langFlag => {
      switch (langFlag.lang) {
        case 'es':
          countries.registerLocale(es);
          break;
        case 'en':
          countries.registerLocale(en);
          break;
        default:
          break;
      }
    });
  }

}
